import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NotifierService } from '../../services/notifier.service';
import { UserService } from '../../services/user.service';
// Duyệt nhiều cấp (Hrm.API HrApprovals) dùng chung cho hợp đồng (objectType 1) và lần tính lương (2).
// openFor(): xem các cấp, gửi duyệt (người gửi), duyệt / từ chối (người đến lượt), huỷ. openInbox(): việc chờ tôi duyệt.
// Quyền: hrApprovalsController 5 gửi (16), 6 duyệt (32), 7 huỷ (64).
export const APPROVAL_STATES = { 0: 'Chờ duyệt', 1: 'Đã duyệt', 2: 'Bị từ chối' };
export class ApprovalPanelComponent {
    constructor(http, notifier, userService) {
        this.http = http;
        this.notifier = notifier;
        this.userService = userService;
        this.changed = new EventEmitter();
        this.isShow = false;
        this.mode = 'detail';
        this.title = '';
        this.data = null;
        this.inbox = [];
        this.inboxType = 0;
        this.approvers = [];
        this.nextApprover = null;
        this.note = '';
        this.busy = false;
        this.userOptions = [];
        this.statusNames = { 0: 'Chờ duyệt', 1: 'Đã duyệt', 2: 'Từ chối', 9: 'Huỷ' };
        this.uri = environment.apiDomain.hrmEndpoint + '/HrApprovals';
    }
    get stateName() {
        return !this.data || this.data.state === null || this.data.state === undefined ? 'Chưa gửi duyệt' : APPROVAL_STATES[this.data.state];
    }
    get canSubmit() { return this.data && this.data.canSubmit && this.data.state !== 0; }
    openFor(objectType, objectKey, title) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.mode = 'detail';
            this.objectType = objectType;
            this.objectKey = objectKey;
            this.title = title;
            this.approvers = [];
            this.note = '';
            this.nextApprover = null;
            this.isShow = true;
            yield this.loadUsers();
            yield this.load();
        });
    }
    openInbox(objectType = 0) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.mode = 'inbox';
            this.inboxType = objectType;
            this.title = 'Việc chờ tôi duyệt';
            this.isShow = true;
            yield this.loadInbox();
        });
    }
    loadInbox() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rs = yield this.http.get(this.uri + '/MyPending').toPromise().catch(e => ({ status: false, message: e && e.message }));
            this.inbox = rs && rs.status ? (rs.data || []).filter(x => !this.inboxType || x.objectType === this.inboxType) : [];
        });
    }
    openItem(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.openFor(item.objectType, item.objectKey, item.title);
        });
    }
    loadUsers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.userOptions.length) {
                return;
            }
            const rs = yield this.userService.GetTdvByOrganization();
            this.userOptions = rs && rs.status ? (rs.data || []).map(u => ({ label: u.name, value: u.userId })) : [];
        });
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rs = yield this.http.get(`${this.uri}/Steps?objectType=${this.objectType}&objectKey=${encodeURIComponent(this.objectKey)}`).toPromise()
                .catch(e => ({ status: false, message: e && e.message }));
            if (!rs || !rs.status) {
                this.notifier.showError(rs && rs.message || 'Không tải được thông tin duyệt.');
                this.data = null;
                return;
            }
            this.data = rs.data;
        });
    }
    userName(id) {
        const u = this.userOptions.find(x => x.value === id);
        return u ? u.label : '#' + id;
    }
    addApprover() {
        if (!this.nextApprover || this.approvers.indexOf(this.nextApprover) >= 0) {
            return;
        }
        this.approvers.push(this.nextApprover);
        this.nextApprover = null;
    }
    removeApprover(i) { this.approvers.splice(i, 1); }
    moveUp(i) {
        if (i <= 0) {
            return;
        }
        const t = this.approvers[i - 1];
        this.approvers[i - 1] = this.approvers[i];
        this.approvers[i] = t;
    }
    post(path, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.busy = true;
            try {
                const rs = yield this.http.post(this.uri + path, body).toPromise();
                if (rs && rs.status) {
                    this.notifier.showSuccess(rs.message);
                    this.note = '';
                    this.approvers = [];
                    yield this.load();
                    this.changed.emit({ objectType: this.objectType, objectKey: this.objectKey, state: this.data && this.data.state });
                }
                else {
                    this.notifier.showError(rs && rs.message || 'Không thực hiện được.');
                }
            }
            catch (e) {
                this.notifier.showError(e && e.message || 'Không thực hiện được.');
            }
            finally {
                this.busy = false;
            }
        });
    }
    submit() {
        if (!this.approvers.length) {
            this.notifier.showWarning('Thêm ít nhất một người duyệt.');
            return;
        }
        return this.post('/Submit', { objectType: this.objectType, objectKey: this.objectKey, approverUserIds: this.approvers, note: this.note });
    }
    act(approve) {
        if (!approve && !this.note.trim()) {
            this.notifier.showWarning('Nhập lý do từ chối.');
            return;
        }
        return this.post('/Act', { objectType: this.objectType, objectKey: this.objectKey, approve, note: this.note });
    }
    cancel() {
        return this.post(`/Cancel?objectType=${this.objectType}&objectKey=${encodeURIComponent(this.objectKey)}`, {});
    }
}
